import { CanDeactivateFn } from '@angular/router';

/** A page that can hold changes not saved yet: it answers whether leaving is fine */
export interface LeavesSafely {
  canDeactivate(): boolean;
}

/** Leaving by any link, menu or the back button asks first while changes are not saved (card 827) */
export const unsavedChangesGuard: CanDeactivateFn<LeavesSafely> = (page) => page.canDeactivate();
